import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import SettingsCard from "./SettingsCard";
import { faCreditCard } from '@fortawesome/free-regular-svg-icons'

function Payment({paymentBar, togglePaymentBar }) {
    return (
    <div className={`notifybar ${paymentBar ? "active" : null}`}>
        <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center" style={{cursor: 'pointer'}}>
                <FontAwesomeIcon icon={faAngleLeft} style={{color: 'white', cursor: 'pointer', fontSize: '14px'}} onClick={() => {togglePaymentBar()}}/>
                <p className="mb-0 fw-semibold ms-3 text-white">Payments Settings</p>
            </div>
            <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={() => {togglePaymentBar()}}/>
        </div>
        <div className="sidebar-navbar" style={{height: 'auto'}}>
            <SettingsCard icon={<FontAwesomeIcon icon={faCreditCard} style={{fontSize: '15px'}}/>} name="Deposit" text="Deposit funds into your account" link="/deposit"/>
            <SettingsCard icon={<FontAwesomeIcon icon={faCreditCard} style={{fontSize: '15px'}}/>} name="Withdraw" text="Withdrawals might take up to 24 hours to process" link="/withdraw"/>
        </div>
    </div>
    )
}

export default Payment